import { render } from "./RoomsDataTable.vue?vue&type=template&id=4b96109e"
import script from "./RoomsDataTable.vue?vue&type=script&lang=js"
export * from "./RoomsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__